import $axios from "@/service/httpServer";
// 获取组织列表
export const getCompany = () => $axios.post('/Web/Backend/Orgnization/tree');

export const refreshOrgs = () => $axios.post('/Web/Backend/Orgnization/loadOrgs');

// 获取设备信息
export const getDeviceInfo = p => $axios.get('/Web/Backend/Device/info', p);

// 获取设备列表
export const getDeviceList = p => $axios.post('/Web/Backend/Device/page', p);

// 获取设备列表
export const getAllDevices = p => $axios.post('/Web/Backend/Device/list', p);

// 修改设备信息
export const updateDevice = p => $axios.post('/Web/Backend/Device/update', p);

// 删除设备
export const delDevice = p => $axios.post('/Web/Backend/Device/delete', p);